import {
  CHKK_CLI_VERSION_MAJORMINORPATCH,
  CHKK_K8S_CONNECTOR_VERSION,
} from 'constants/chkk-version';
import * as Sentry from '@sentry/browser';
import semver from 'semver';

export const K8sConnectorVersion = () => {
  const checkOutdated = (version: string) => {
    try {
      if (!version || version.startsWith('v1')) {
        // All users running v1.x.x (older versioning format) should be prompted to upgrade to latest version of K8s connector
        return true;
      } else {
        // Remove the prepatch or prerelease tags from the versions before comparing
        const cleanVersion = version.replace('v', '').split('-')[0];
        const coercedCleanVersion = semver.coerce(cleanVersion);
        const cleanChkkVersion = CHKK_K8S_CONNECTOR_VERSION.replace(
          'v',
          '',
        ).split('-')[0];
        if (coercedCleanVersion) {
          return semver.lt(coercedCleanVersion, cleanChkkVersion);
        } else {
          // If the version is not a valid semver, we don't want to prompt the user to upgrade
          return false;
        }
      }
    } catch (err) {
      Sentry.captureException(err);
      return false;
    }
  };

  return {
    checkOutdated,
  };
};

export const ChkkCliVersion = () => {
  const checkOutdated = (version: string) => {
    try {
      // Remove the prepatch or prerelease tags from the versions before comparing
      const cleanVersion = version.replace('v', '').split('-')[0];
      const coercedCleanVersion = semver.coerce(cleanVersion);
      const cleanCLIVersion = CHKK_CLI_VERSION_MAJORMINORPATCH.replace(
        'v',
        '',
      ).split('-')[0];

      if (coercedCleanVersion) {
        return semver.lt(coercedCleanVersion, cleanCLIVersion);
      } else {
        // If the version is not a valid semver, we don't want to prompt the user to upgrade
        return false;
      }
    } catch (err) {
      Sentry.captureException(err);
      return false;
    }
  };

  return {
    checkOutdated,
  };
};
